import React from 'react';
const AppsSvg = () => React.createElement("span", { className: "sirius-icon sirius-icon-apps" });
AppsSvg.Enhance = () => React.createElement("span", { className: "sirius-icon sirius-icon-apps sirius-icon-apps-enhance" });
export default AppsSvg;
